import { Navigate, type RouteObject } from 'react-router';
import { AuthProvider } from './auth/AuthContext';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { LoginPage } from './pages/Login/LoginPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { DashboardPage } from './pages/Dashboard';

// Apart from the router so the tests can mount the same tree in memory.
export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthProvider>
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      </AuthProvider>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthProvider>
        <LoginPage />
      </AuthProvider>
    ),
  },
  {
    path: '/change-password',
    element: (
      <AuthProvider>
        <ProtectedRoute>
          <ChangePasswordPage />
        </ProtectedRoute>
      </AuthProvider>
    ),
  },
  { path: '*', element: <Navigate to="/" replace /> },
];
